import { render, staticRenderFns } from "./RekomendasiPenilaianPelaksanaan.vue?vue&type=template&id=80264c02&"
import script from "./RekomendasiPenilaianPelaksanaan.vue?vue&type=script&lang=js&"
export * from "./RekomendasiPenilaianPelaksanaan.vue?vue&type=script&lang=js&"
import style0 from "./RekomendasiPenilaianPelaksanaan.vue?vue&type=style&index=0&id=80264c02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports